var path = '/modules/media/components/al-media-thumbnail/lightbox-template.tpl.html';
var html = "<button class=\"close\" ng-click=\"vm.close()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n    <h3>Preview for: {{vm.file.name}}</h3>\n</div>\n<div class=\"modal-body\">\n    <img ng-src=\"{{vm.file.url}}\" ng-if=\"vm.file.url\" style=\"max-width: 100%; height: auto;\"/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/media/components/al-media-thumbnail/lightbox-template.tpl.html
// module id = 2134
// module chunks = 1